
export default {
  appTitle: process.env.VUE_APP_TITLE,
  appVersion: process.env.VUE_APP_VERSION,
  baseUrl: process.env.VUE_APP_BASE_URL,
  // userBaseUrl: "/membersite",
  userBaseUrl: "/member",
  userReportUrl: "/report",
  bankList: [],
  account_name: "MMK555",
  nekoGame: process.env.VUE_APP_NEKO_URL,
  wbetWidget: process.env.VUE_APP_WBET_WIDGET,
  wBetUrl: process.env.VUE_APP_WBET_URL,
  live22Game: process.env.VUE_APP_LIVE22_URL,
  kingkongGame: process.env.VUE_APP_KINGKONG_URL,
  pegGame:process.env.VUE_APP_PEG_URL,
  uuslotGame:process.env.VUE_APP_UUSLOT_URL,
  useConfigUrl: process.env.VUE_APP_STATIC_URL,
  lgCasino:process.env.VUE_APP_LGCASINO_URL,

  getDomain(url, subdomain) {
    subdomain = subdomain || false;

    url = url.replace(/(https?:\/\/)?(www.)?/i, "");
    
    if (!subdomain) {
      url = url.split(".");

      url = url.slice(url.length - 2).join(".");
    }
    
    if (url.indexOf("/") !== -1) {
      return url.split("/")[0];
    }

    return url;
  },

  getBaseUrl() {
    if (this.useConfigUrl == "true") {
      return this.baseUrl;
    }
    var domain = this.getDomain(window.location.hostname, false);
    if (domain != "localhost") {
      if(this.useConfigUrl == "true"){
        return this.baseUrl;
      }else{
        return "https://api." + domain;
      }     
    } else { 
      return this.baseUrl;
    }
  },

  memberLogin() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberlogin";
  },
  getBalance() {
    return this.getBaseUrl() + this.userBaseUrl + "/getbalance";
  },
  addSecondary(){
    return this.getBaseUrl() + this.userBaseUrl + "/mbaddsecondary";
  },
  updatePassword() {
    return this.getBaseUrl() + this.userBaseUrl + "/updatepassword";
  },
  manualDeposit() {
    return this.getBaseUrl() + this.userBaseUrl + "/depositticket";
  },
  addWithdrawTicket() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawticket";
  },
  getMemberTicketList() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketlist";
  },
  getPromo(){
    return this.getBaseUrl() + this.userBaseUrl + "/getpromolist"
  },
  getMemberStatement() {
    return this.getBaseUrl() + this.userReportUrl + "/getdailystatement";
  },
  // getMemberTransferDetails() {
  //   return this.getBaseUrl()+ this.userBaseUrl + "/mbsettlementhistory";
  // },
  getGameResultSlot(){
    return this.getBaseUrl() + this.userReportUrl + "/gameresultslot";
  },
  getGameResultLivecasino(){
    return this.getBaseUrl() + this.userReportUrl + "/gameresultlivecasino";
  },
  getGameResultSb(){
    return this.getBaseUrl() + this.userReportUrl + "/gameresultsports"
  },
  getPlatformWinLose() {
    return this.getBaseUrl() + this.userReportUrl + "/getdailywinlosebyprovider";
  },
  // getTopTenDepositWithdraw(){
  //   return this.getBaseUrl() + this.userBaseUrl + "/gettoptendw";
  // },

  // games
  launchWbet(){
    return this.wBetUrl + "/launchgame"
  },
  getNekoGameList(){
    return this.nekoGame + "/getgamelist"
  },
  launchNeko(){
    return this.nekoGame + "/launchgame"
  },
  getLive22GameList(){
    return this.live22Game + "/getgamelist?lang=en"
  },
  launchLive22(){
    return this.live22Game + "/launchgame"
  },
  getLive22FishGameList(){
    return this.live22Game + "/getfishgamelist?lang=en"
  },
  getKingkongGameList(){
    return this.kingkongGame + "/getgamelist"
  },
  launchKingkong(){
    return this.kingkongGame + "/launchgame"
  },
  getKingkongFishGameList(){
    return this.kingkongGame + "/getfishgamelist"
  },
  getPegGameList(){
    return this.pegGame + "/getgamelist"
  },
  launchPeg(){
    return this.pegGame + "/launchgame"
  },
  getUuslotGameList(){
    return this.uuslotGame + "/getgamelist?lang=en"
  },
  launchUuslot(){
    return this.uuslotGame + "/launchgame"
  },

  //game result
  getNekoResult(){
    return this.nekoGame + "/getbetdetail"
  },
  getLive22Result(){
    return this.live22Game + "/getbetdetail"
  },
  getKingkongResult(){
    return this.kingkongGame + "/getbetdetail"
  },
  getPegResult(){
    return this.pegGame + "/getbetdetail"
  },
  getUuResult(){
    return this.uuslotGame + "/getbetdetail"
  },

  //casino
  launchLg(){
    return this.lgCasino + "/launchgame"
  }
};
